<tgrid-restoration-metric-map-widget
  title="Area Under the Curve (AUC)"
  metric="auc"
  mapId="restoration-metric-auc-map-widget"
  countyLabelPrefix="Largest AUC:"
  subtitle="Area Under the Curve (AUC) demonstrates units of customer-minutes – combining Impact Level & Event Duration into one metric."
  exportFileName="restoration_metric_auc">
</tgrid-restoration-metric-map-widget>
